export const theme = {
  token: {
    colorPrimary: "#0A4D68",
  },
};
